import React from 'react';
import ModalSummary from '../ModalSummary';
import { useTrackingPage } from 'pages/Tracking/Tracking.hooks';

export default function Stops() {
  const { data: order } = useTrackingPage();

  if (!order) return null;
  return <ModalSummary order={removeDriversAndVehicles(order)} />;
}

function removeDriversAndVehicles(order) {
  return {
    ...order,
    drivers: null,
    vehicles: null,
  };
}
